import React, { Fragment, FunctionComponent } from 'react';
import { useTranslation } from '@rbx/intl';
import { TOperationExtensions } from '@rbx/docsite-utilities';
import StandardMarkdownNoMargin from '@modules/ui/markdown/components/StandardMarkdownNoMargin';
import { Typography } from '@rbx/ui';
import getRateLimitMarkdown from '../utils/getRateLimitMarkdown';

interface LimitsContainerProps {
  rateLimits: TOperationExtensions['x-roblox-rate-limits'];
}

const LimitsContainer: FunctionComponent<React.PropsWithChildren<LimitsContainerProps>> = ({
  rateLimits,
}) => {
  const { translate } = useTranslation();

  if (!rateLimits) {
    return null;
  }

  return (
    <Fragment>
      <Typography variant='h4'>{translate('Label.Limits')}</Typography>
      <StandardMarkdownNoMargin>
        {getRateLimitMarkdown(
          translate,
          rateLimits as TOperationExtensions['x-roblox-rate-limits'] & {
            perApiKeyOwner: {
              // eslint-disable-next-line camelcase
              max_in_period?: number;
            };
            perOauth2Authorization: {
              // eslint-disable-next-line camelcase
              max_in_period?: number;
            };
          },
        )}
      </StandardMarkdownNoMargin>
    </Fragment>
  );
};

export default LimitsContainer;
